import type { GetCourseDetail200LocalizedSectionsItemSectionsItemLecturesItem } from './getCourseDetail200LocalizedSectionsItemSectionsItemLecturesItem';

export type GetCourseDetail200LocalizedSectionsItemSectionsItem = {
  /**
   * 섹션 설명
   * @nullable
   */
  description?: string | null;
  /** 섹션 ID */
  id: string;
  /** 섹션에 포함된 강의 목록 */
  lectures: GetCourseDetail200LocalizedSectionsItemSectionsItemLecturesItem[];
  /** 섹션 순서 */
  order: number;
  /** 섹션 제목 */
  title: string;
};
